/*
SiderMenu.js
侧边栏siderMenu
 */

import React, { useEffect, useState } from 'react';
import { Flex, Button, Row, Col, message } from 'antd';
import { FunctionOutlined, PlusOutlined, DeleteOutlined, LineChartOutlined, FileOutlined } from "@ant-design/icons";

import { Point5FullSVG } from "../../Common/PointFive/Point5FullIcon_Dark";
import SiderConversations from "./SiderConversations/SiderConversations";
import {
    saveSession,
    getAllSessions,
    deleteSession,
    clearAllSessions,
    updateSessionTitle,
    getSessionMessages
} from "../../Model/IndexedDB";
import { createNewSession } from "../../Model/Session/createNewSession";
import { ACTIVE_SESSION_KEY } from "../../Common/constants";
import DoubleIncPage from "../../ToolsPage/DoubleIncPage/DoubleIncPage";
import LineAnaPage from '../../ToolsPage/LineAnaPage/LineAnaPage';
import DatFileEditorPage from '../../ToolsPage/DatFileEditorPage/DatFileEditorPage';

const SiderMenu = ({ newSessionTitle, isMobile, drawerOnClose, isDrawerOpen, handleChangeSession }) => {
    // sessions
    const [sessions, setSessions] = useState([]);
    const [doubleIncShow, setDoubleIncShow] = useState(false);
    const [lineAnaPageShow, setLineAnaPageShow] = useState(false);
    const [datFileEditorShow, setDatFileEditorShow] = useState(false);

    // 加载会话数据,只在挂载的时候更新
    useEffect(() => {
        refreshSessions();
    }, []);

    // 移动端抽屉打开的时候也要更新
    useEffect(() => {
        if (isDrawerOpen === true) {
            loadSessions().then();
        }
    }, [isDrawerOpen]);

    // 更新新的session标题
    useEffect(() => {
        if (isMobile !== true) {
            getAllSessions().then((sessions) => {
                loadSessions().then();
            });
        }
    }, [newSessionTitle]);

    // 重新刷新sessions
    const refreshSessions = () => {
        getAllSessions().then((sessions) => {
            // 当存在会话的时候，直接激活第一个会话。否则创建一个新的，并激活
            if (sessions.length > 0) {
                sessionStorage.setItem(ACTIVE_SESSION_KEY, sessions[0].sessionID);
                loadSessions().then();
                handleChangeSession();
            } else {
                const newSession = createNewSession();
                saveSession(newSession).then(() => {
                    sessionStorage.setItem(ACTIVE_SESSION_KEY, newSession.sessionID);
                    loadSessions().then();
                    handleChangeSession();
                });
            }
        });
    };

    // 载入sessions
    const loadSessions = async () => {
        const data = await getAllSessions();
        setSessions(data);
    };

    // 添加新会话
    const addSession = async () => {
        const newSession = createNewSession();
        await saveSession(newSession);
        sessionStorage.setItem(ACTIVE_SESSION_KEY, newSession.sessionID);
        loadSessions().then(() => {
            handleChangeSession();
        });
    };

    // 删除会话
    // 具体逻辑要结合SiderConversations中的handleOnActiveChange一起
    const handleDeleteSession = async (deletedSessionId) => {
        await deleteSession(deletedSessionId);
        message.success('删除成功');
        const activeSessionID = sessionStorage.getItem(ACTIVE_SESSION_KEY);
        getAllSessions().then((sessions) => {
            if (sessions.length > 0) {
                // 删除的时候删除的id与当前激活的是一个的时候，就把第一个激活
                if (deletedSessionId === activeSessionID) {
                    sessionStorage.setItem(ACTIVE_SESSION_KEY, sessions[0].sessionID);
                }
                loadSessions().then(() => {
                    handleChangeSession();
                });
            } else {
                const newSession = createNewSession();
                saveSession(newSession).then(() => {
                    sessionStorage.setItem(ACTIVE_SESSION_KEY, newSession.sessionID);
                    loadSessions().then(() => {
                        handleChangeSession();
                    });
                });
            }
        });
    };

    // 清空会话
    const handleClearAllSession = async () => {
        await clearAllSessions();
        loadSessions().then(() => {
            message.success('已清空所有会话');
            const newSession = createNewSession();
            saveSession(newSession).then(() => {
                sessionStorage.setItem(ACTIVE_SESSION_KEY, newSession.sessionID);
                loadSessions().then(() => {
                    handleChangeSession();
                });
            });
        });
    };

    // 更新会话的title
    const handleUpdateSessionTitle = async ({ sessionID, newTitle }) => {
        await updateSessionTitle(sessionID, newTitle);
        loadSessions().then();
    };

    // 打开双增公式页面
    const handleDoubleIncBtnClicked = () => {
        setDoubleIncShow(true);
    };

    // 关闭双增公式页面
    const handleDoubleIncPageClosed = () => {
        setDoubleIncShow(false);
    };

    // 曲线分析页面开启和关闭
    const handleLineAnaBtnClicked = () => {
        setLineAnaPageShow(true);
    }
    const handleLineAnaPageClosed = () => {
        setLineAnaPageShow(false);
    }

    // dat文件编辑器页面开启和关闭
    const handleDatFileEditorBtnClicked = () => {
        setDatFileEditorShow(true);
    }
    const handleDatFileEditorPageClosed = () => {
        setDatFileEditorShow(false);
    }

    return (
        <Flex justify='flex-start' gap='middle' vertical={true} style={{ height: '100%' }} flex>
            {/*logo*/}
            {!isMobile &&
                <Row justify='center' align='middle' style={{ marginTop: '20px' }}>
                    <Col span={22}>
                        <Point5FullSVG style={{ height: '4vh', width: 'auto' }} />
                    </Col>
                </Row>
            }
            {/*添加新会话*/}
            <Row justify='center' align='middle' style={{ marginTop: '20px' }}>
                <Col span={22}>
                    <Button color='default' variant='filled' icon={<PlusOutlined />} block onClick={addSession}>
                        添加新会话
                    </Button>
                </Col>
            </Row>
            {/* 双增公式 */}
            <Row justify='center' align='middle'>
                <Col span={22}>
                    <Button color='default' variant='filled' icon={<FunctionOutlined />}
                        onClick={handleDoubleIncBtnClicked} block>双增公式</Button>
                    <DoubleIncPage isMobile={isMobile} doubleIncShow={doubleIncShow} onClose={handleDoubleIncPageClosed} />
                </Col>
            </Row>
            {/* 热力曲线分析 */}
            <Row justify='center' align='middle'>
                <Col span={22}>
                    <Button color='default' variant='filled' icon={<LineChartOutlined />}
                        onClick={handleLineAnaBtnClicked} block>热力曲线分析</Button>
                    <LineAnaPage isMobile={isMobile} LineAnaPageShow={lineAnaPageShow} onClose={handleLineAnaPageClosed}/>
                </Col>
            </Row>
            {/* .dat文件编辑器 */}
            <Row justify='center' align='middle'>
                <Col span={22}>
                    <Button color='default' variant='filled' icon={<FileOutlined />}
                        onClick={handleDatFileEditorBtnClicked} block>.dat文件编辑器</Button>
                    <DatFileEditorPage isMobile={isMobile} datFileEditorShow={datFileEditorShow} onClose={handleDatFileEditorPageClosed} />
                </Col>
            </Row>
            {/*占据剩余位置，多出来的变为滑动页面*/}
            <Row justify='center' align='middle' style={{ flexGrow: 1, overflow: "hidden", marginBottom: '20px', }}>
                <Col span={22} style={{ height: "100%", overflow: "auto" }}>
                    <SiderConversations sessions={sessions} deleteSession={handleDeleteSession}
                        loadSessions={loadSessions}
                        renameSession={handleUpdateSessionTitle} isMobile={isMobile}
                        drawerOnClose={drawerOnClose} handleChangeSession={handleChangeSession} />
                </Col>
            </Row>
            <Row justify='center' align='middle' style={{ marginBottom: (isMobile ? '10px' : '30px') }}>
                <Col span={22}>
                    {(sessions.length > 0) && (
                        <Button icon={<DeleteOutlined />} onClick={handleClearAllSession} danger block>
                            删除所有会话
                        </Button>
                    )}
                </Col>
            </Row>
        </Flex>
    );
};

export default SiderMenu;